// @flow
import React from 'react';

import ModalWithMultiSelectList from '../modalWithMultiSelectList/modalWithMultiSelectList';

import styles from './realTimeSummary.scss';

type Props = {
  configuration: Object
};
type State = {
  showModal: boolean,
  multiSelectListArr: Array<any>,
  multiSelectListArrOriginal: Array<any>,
  selectedCategory: string,
  configCLone: Object,
  settingsConfig: Array<any>
};

class RealTimeAlertsSettings extends React.Component<Props, State> {
  constructor(props: Object) {
    super(props);
    this.state = {
      showModal: false,
      multiSelectListArr: [],
      multiSelectListArrOriginal: [],
      selectedCategory: '',
      configCLone: this.props.configuration,
      settingsConfig: Object.keys(this.props.configuration)
    };

    this.accessorKeys = {
      key: 'eventName',
      selectFlag: 'isActive'
    };
  }

  componentWillReceiveProps(nextProps: Object) {
    this.setConfig(nextProps);
  }

  onSettingsSave(configArr: Array<any>) {
    const configCloneState = this.state.configCLone;
    const { selectedCategory } = this.state;

    configCloneState[selectedCategory].userEventMappingDTOList = configArr;
    const activeCountArray = configArr.filter(item => item.isActive);
    configCloneState[selectedCategory].activeCount = activeCountArray.length;

    this.setState({
      configCLone: configCloneState
    });

    // eslint-disable-next-line no-console
    console.log('category after save: ', this.state.configCLone);
    this.closeModal();
  }

  setConfig(props: Object) {
    this.setState({
      configCLone: props.configuration,
      settingsConfig: Object.keys(props.configuration)
    });
  }

  multiSelectListArr: Array<any>;
  accessorKeys: Object;
  openSettingsModal(title: string) {
    // set multiSelectListArr also on the basis of setting
    const selectedCategory = title;
    const multiSelectListArr =
      this.state.configCLone[selectedCategory] &&
      this.state.configCLone[selectedCategory].userEventMappingDTOList;

    const multiSelectListArrOriginal =
      this.props.configuration[selectedCategory] &&
      this.props.configuration[selectedCategory].userEventMappingDTOList;

    this.setState({
      showModal: true,
      multiSelectListArr,
      multiSelectListArrOriginal,
      selectedCategory
    });
  }

  closeModal() {
    this.setState({
      showModal: false
    });
  }

  renderModal() {
    return (
      <ModalWithMultiSelectList
        showLoader={false}
        showModal={this.state.showModal}
        title="Real Time Settings"
        multiSelectListArr={this.state.multiSelectListArr}
        multiSelectListArrOriginal={this.state.multiSelectListArrOriginal}
        accessorKeys={this.accessorKeys}
        onSave={config => this.onSettingsSave(config)}
        closeModal={() => {
          this.closeModal();
        }}
      />
    );
  }

  renderSettingRow(title: string, obj: Object) {
    return (
      <div className="l-row a-center">
        <div className={`${styles.settingsText} l-row a-center`}>
          <div className={`${styles.settingTitle}`}>{title}</div>
          <div className={`${styles.settingCount}`}>
            ({obj && obj.activeCount} selected)
          </div>
        </div>
        <div
          className={`${styles.editBtn} l-row a-center j-center`}
          onClick={() => this.openSettingsModal(title)}
        >
          Edit
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="real-time-summary-wrapper">
        <div className={`${styles.realTimeSummaryTitle}`}>
          Real Time Alert Settings
        </div>
        <div className={`${styles.settingsWrapper}`}>
          {this.state.settingsConfig.map((key, i) => (
            <div key={i} className={`${styles.settingRow}`}>
              {this.renderSettingRow(
                key,
                this.state.configCLone && this.state.configCLone[key]
              )}
            </div>
          ))}
          {this.renderModal()}
        </div>
      </div>
    );
  }
}

export default RealTimeAlertsSettings;
